import React, { Component } from 'react'
import { Radio } from 'antd'
import { API_DOMAIN } from '../../config'
import { postData, fetchData } from '../../util/index'

export default class index extends Component {
  state = { radioValue: 2 }

  componentDidMount() {
    this.getStatisticType()
  }

  // 获取默认查询时间段
  getStatisticType = () => {
    const clubId = sessionStorage.getItem('club_id')
    this.setState({
      radioValue: 2,
    })
    this.props.typeEvent(2)
    return

    const endpoint = `${API_DOMAIN}/BusinessApi/statisticType?clubId=${clubId}`
    fetchData(endpoint).then((res) => {
      if (res && res.status == 1) {
        this.setState({
          radioValue: +res.data.type,
        })
        this.props.typeEvent(+res.data.type)
      }
    })
  }

  // 设置默认查询时间段 type: 1: 9点 2：0点
  settingsStatisticType = (type) => {
    const clubId = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/BusinessApi/statisticType`
    postData(
      endpoint,
      'POST',
      JSON.stringify({
        clubId,
        type,
      })
    )
  }

  radioChange = (e) => {
    // this.settingsStatisticType(e.target.value)
    this.setState({
      radioValue: e.target.value,
    })
    this.props.typeEvent(e.target.value)
  }

  textView = () => {
    return <span style={{ marginLeft: '1rem' }}>按0点到0点统计</span>
  }

  radioView = () => {
    const { radioValue } = this.state
    return (
      <Radio.Group
        onChange={this.radioChange}
        value={radioValue}
        style={{ marginLeft: '1rem' }}
      >
        <Radio value={1}>按9点到9点统计</Radio>
        <Radio value={2}>按0点到0点统计</Radio>
      </Radio.Group>
    )
  }

  render() {
    return this.radioView()
  }
}



// WEBPACK FOOTER //
// ./src/components/nineAndZeroRadio/index.js